import { Button, Spinner } from '@crm/ui';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { toErrorMessage } from '@/modules/auth/utils';
import type { Unit } from '@/modules/company';
import { type PhoneLine, useConnectLine } from '../api';
import { andamentoDaUnidade } from './unit-status';

export function WhatsappProgress({ unit, linha }: { unit: Unit; linha: PhoneLine | null }) {
  const registrar = useConnectLine();
  const andamento = andamentoDaUnidade(unit, linha);

  if (!andamento.problema) {
    return (
      <p className="border-t border-border pt-4 text-sm text-muted-foreground">
        {andamento.aguarda}
      </p>
    );
  }

  return (
    <div className="space-y-2 border-t border-border pt-4">
      <div className="flex flex-wrap items-center gap-3 rounded-card border border-destructive/40 bg-destructive/10 px-3 py-2.5">
        <AlertTriangle className="h-4 w-4 shrink-0 text-destructive" aria-hidden />
        <p className="min-w-0 flex-1 text-sm text-destructive">{andamento.aguarda}</p>

        {linha ? (
          <Button
            variant="outline"
            disabled={registrar.isPending}
            onClick={() => registrar.mutate({ id: linha.id, unitId: unit.id })}
          >
            {registrar.isPending ? <Spinner /> : <RefreshCw className="h-4 w-4" />}
            Registrar de novo
          </Button>
        ) : null}
      </div>

      {registrar.error ? (
        <p className="text-sm text-destructive">{toErrorMessage(registrar.error)}</p>
      ) : null}
    </div>
  );
}
